import { render, staticRenderFns } from "./InformationNotMaintained.vue?vue&type=template&id=22a6f842&scoped=true&"
import script from "./InformationNotMaintained.vue?vue&type=script&lang=js&"
export * from "./InformationNotMaintained.vue?vue&type=script&lang=js&"
import style0 from "./InformationNotMaintained.vue?vue&type=style&index=0&id=22a6f842&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a6f842",
  null
  
)

export default component.exports